<template>
    <div class="row">
        <div class="col-12 mb-1">
            <label class="form-label">Şube</label>
            <v-validator :errors="errors" parameter="ResponsibleBranchId" :watch="branch">
                <v-select-list :options="branches" label="Name" v-model="branch" placeholder="Şube"></v-select-list>
            </v-validator>
        </div>
        <div class="col-12 mb-1">
            <label class="form-label">Personel</label>
            <v-validator :errors="errors" parameter="HREmployeeId" :watch="employee">
                <v-select-list :options="employees" label="FullName" v-model="employee" placeholder="Personel"></v-select-list>
            </v-validator>
        </div>
        <div class="col-12">
            <label class="form-label">Başlangıç Tarihi</label>
            <v-validator :errors="errors" parameter="StartDate" :watch="value.StartDate">
                <v-date-picker v-model="value.StartDate" placeholder="Başlangıç Tarihi"></v-date-picker>
            </v-validator>
        </div>
    </div>
</template>

<script>
import CompanyApi from '@/api/company'
import EmployeeOperationsApi from '@/api/employee-operations'
export default {
    props:{
        value:Object,
        errors:Object
    },
    data(){
        return{
            branches:[],
            employees:[]
        }
    },  
    mounted(){
        this.getBranches()
        this.getEmployees()
    },
    methods:{
        getBranches(){
            CompanyApi.Branch.ListByCode("O").then(res=>{ 
                this.branches = res.data.Data
            })
        },
        getEmployees(){
            EmployeeOperationsApi.HRAssignToBranch.EmployeeList().then(res=>{
                this.employees = res.data.Data
            })
        }
    },
    computed:{
        branch:{
            get:function(){
                return this.branches.find(b=>b.Id==this.value.ResponsibleBranchId)
            },
            set:function(value){
                this.value.ResponsibleBranchId = value?.Id || null
            }
        },
        employee:{
            get:function(){
                return this.employees.find(b=>b.Id==this.value.HREmployeeId)
            },
            set:function(value){
                this.value.HREmployeeId = value?.Id || null
            }
        },
    }
}
</script>

<style>

</style>